import * as React from 'react';

import { TextAlignment } from '@gitbook/api-client';

export { TextAlignment };

/** Context to access the current text alignment. */
export const TextAlignmentContext = React.createContext<TextAlignment>(TextAlignment.Start);

/** Class names for each text alignment. */
export const textAlignmentClassName: Record<TextAlignment, string> = {
    start: 'text-left',
    center: 'text-center',
    end: 'text-right',
};
export const textAlignmentFlexClassName: Record<TextAlignment, string> = {
    start: 'justify-start',
    center: 'justify-center',
    end: 'justify-end',
};
